import React from 'react';

const Slider = React.forwardRef(({ 
  className = '', 
  value = [0], 
  onValueChange, 
  max = 100, 
  min = 0, 
  step = 1,
  disabled,
  ...props 
}, ref) => {
  const handleChange = (index, newValue) => {
    const newValues = [...value];
    newValues[index] = Math.max(min, Math.min(max, newValue));
    
    // Ensure min <= max for range sliders
    if (value.length === 2) {
      if (index === 0 && newValues[0] > newValues[1]) {
        newValues[1] = newValues[0];
      } else if (index === 1 && newValues[1] < newValues[0]) {
        newValues[0] = newValues[1];
      }
    }
    
    onValueChange && onValueChange(newValues);
  };

  const getPercentage = (val) => ((val - min) / (max - min)) * 100;

  return (
    <div 
      ref={ref}
      className={`relative flex w-full touch-none select-none items-center ${className}`}
      {...props}
    >
      <div className="relative h-2 w-full grow overflow-hidden rounded-full bg-secondary">
        {/* Track highlight for range */}
        {value.length === 2 && (
          <div 
            className="absolute h-full bg-primary"
            style={{
              left: `${getPercentage(value[0])}%`,
              width: `${getPercentage(value[1]) - getPercentage(value[0])}%`
            }}
          />
        )}
        
        {/* Single value track */}
        {value.length === 1 && (
          <div 
            className="absolute h-full bg-primary"
            style={{ width: `${getPercentage(value[0])}%` }}
          />
        )}
        
        {/* Thumbs */}
        {value.map((val, index) => (
          <div
            key={index}
            className="absolute h-5 w-5 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-primary bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 cursor-pointer"
            style={{ 
              left: `${getPercentage(val)}%`,
              top: '50%'
            }}
            onMouseDown={(e) => {
              if (disabled) return;
              
              const startX = e.clientX;
              const startValue = val;
              const rect = e.currentTarget.parentElement.getBoundingClientRect();
              
              const handleMouseMove = (e) => {
                const deltaX = e.clientX - startX;
                const deltaPercentage = (deltaX / rect.width) * 100;
                const deltaValue = (deltaPercentage / 100) * (max - min);
                const newValue = Math.round((startValue + deltaValue) / step) * step;
                
                handleChange(index, newValue);
              };
              
              const handleMouseUp = () => {
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
              };
              
              document.addEventListener('mousemove', handleMouseMove);
              document.addEventListener('mouseup', handleMouseUp);
            }}
          />
        ))}
      </div>
    </div>
  );
});

Slider.displayName = 'Slider';

export { Slider };